<template>
  <div>
    <b-form-input
        v-model="field"
        :state="errorState"
        :readonly="readonly"
        :style="style"
        ref="field"
        class="form-control form-control-sm"
        @keyup="Keyup($event)"
        @focus="Focus"
        @blur="Blur"
    />
  </div>
</template>

<script>

import { BFormInput } from 'bootstrap-vue'

export default {
  name: 'EuroField',
  components: {
    BFormInput,
  },
  data() {
    return {
      field: 0,
      fieldData: 0,
      watch: 0,
      errorState: null,
      readonly: false,
      style: '',
    }
  },
  mounted() {
    this.Blur()
  },
  methods: {
    Set(value) {
      this.field = value
      this.fieldData = this.field
      this.Blur()
    },
    SetReadonly(state) {
      this.readonly = state
      this.style = 'color: white'
    },
    Keyup(event) {
      this.field = this.field.toString().replace(/[^,-[0-9]/g, '')
      this.field = this.field.toString().replace(",", '.')
      this.fieldData = this.field
      if (event.which == 13) {
        this.Format()
      }
    },
    Format() {
      this.field = this.field.toString().replace(/[^,-[0-9]/g, '')
      this.watch = new Date()

    },
    Focus() {
      this.fieldData = this.fieldData.toString().replace('.', ',')
      this.field = this.fieldData
      this.$nextTick(() => this.$refs.field.$el.select())
    },
    Blur() {
      this.fieldData = this.fieldData.toString().replace(',', '.')
      if (this.fieldData.split(',').length >= 2) {
        this.errorState = false
      } else {
        this.field = this.$options.filters.currency(this.fieldData)
        this.errorState = null
      }
    },
  },
}
</script>

<style scoped>

</style>
